import { createAction, props } from '@ngrx/store';
import { IPrivacyData, IPrivacyModel } from '@partners/api';

export class PrivacyActions {
  static reset = createAction('[Privacy] Reset State');
  static load = createAction('[Privacy] Load');
  static loadSuccess = createAction('[Privacy] Load Success', props<{ model: IPrivacyModel; data: IPrivacyData }>());
  static loadFailure = createAction('[Privacy] Load Failure', props<{ error: any }>());
  static submit = createAction('[Privacy] Submit');
  static submitSuccess = createAction(
    '[Privacy] Submit Success',
    props<{ model: IPrivacyModel; data: IPrivacyData }>()
  );
  static submitFailure = createAction('[Privacy] Submit Failure', props<{ error: any }>());
}
